import React from 'react';
import ExpandMoreSharpIcon from '@mui/icons-material/ExpandMoreSharp';
import styles from './PlatformSwitcher.module.scss';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import Alfan from './../../assets/images/Alfan.png';
import {haveSegmentPermission} from '../../features/util';
import {useSelector} from 'react-redux';
import {getConfig} from '../../features/stores/config.slice';

const switchOptions = [{
    key: 'link',
    url: `${window?.location?.origin}`,
    text: 'link',
}, {
    key: 'earnings',
    url: `${window?.location?.origin}/earnings/dashboard`,
    text: 'earnings',
}];

const PlatformSwitcher = () => {
  const [open, setOpen] = React.useState(false);
  const config = useSelector(getConfig).data || [];
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  let finalSwitchOptions = switchOptions;
  const havePermision = haveSegmentPermission(config, 'monetize') && !haveSegmentPermission(config, 'monetizeBlocklist');
  finalSwitchOptions = havePermision ? finalSwitchOptions : finalSwitchOptions.filter((e) => e.key != 'earnings');

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  const handleOpenUrl = (url: string) => {
    window.location.href = url;
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <span className={styles.logo_container} ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}>
            <div className={styles.logo}>
                <div className={styles.logo_row_one}>
                    <img src={Alfan} />
                </div>
                <div className={styles.logo_row_two}>
                    <div className={styles.title}>alfan</div>
                    <div className={styles.sub_title}>media kit</div>
                </div>
            </div>
            <div>
                <ExpandMoreSharpIcon />
            </div>
        </span>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
          style={{zIndex: 5, width: '200px'}}
        >
          {({TransitionProps, placement}) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    {finalSwitchOptions.map((e) => (
                        <MenuItem sx={[
                            {
                              '&:hover': {
                                color: '#7066FF',
                              },
                            },
                          ]} key={e.key} style={{background: 'white'}} onClick={() => handleOpenUrl(e?.url)}><div>
                            {/* <a href={e.url}><img src={e.imgSrc} style={{height: '30px'}} /></a> */}
                            <div className={styles.logo}>
                                <div className={styles.logo_row_one}>
                                    <img src={Alfan} />
                                </div>
                                <div className={styles.logo_row_two}>
                                    <div className={styles.title}>alfan</div>
                                    <div className={styles.sub_title}>{e.text}</div>
                                </div>
                            </div>
                        </div></MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
};

export default PlatformSwitcher;
